module.exports = __webpack_public_path__ + "img/ebay.e1fbe929.svg";